import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/app/global-error.tsx");
